import * as React from "react";
export default () => {
  return <div>Lägg till extra debiteringsrader för avtalet</div>;
};
